<template>
    <v-dialog v-model="open" max-width="420" persistent>
        <v-card>
            <v-card-title class="headline">{{title}}</v-card-title>
            <v-card-text>{{message}}</v-card-text>
            <v-card-actions class="justify-center pb-4">
                <v-btn color="primary" outlined @click="login">Log in</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'GlobalSessionTimeoutDialog',
    computed: {
        open: {
            get() { return this.$store.getters['isSessionTimeoutOpen'] && !this.$route.meta?.skipSessionTimeout },
            set(v) { this.$store.commit('setSessionTimeoutOpen', v) }
        },
        title(){
            if(this.isIdleProp){
                return 'Your session has timed out'
            }
            else{
                return 'Your session has expired'
            }
        },
        message(){
            if(this.isIdleProp){
                return 'Your session has expired due to inactivity set by your administration team. Follow the link below to log in again.'
            }
            else{
                return 'For your protection, your session has ended after reaching the maximum allowed time. This helps keep your account and data secure. Please log in again to continue.'
            }
        }
    },
    props:{
        isIdleProp: {
            type: Boolean,
            default: false
        }
    },
    mounted(){
        if (typeof document !== 'undefined' && this.open) {
            document.body.classList.add('session-timeout-active')
        }
    },
    watch: {
        open(val){
            if (typeof document !== 'undefined') {
                if (val) document.body.classList.add('session-timeout-active')
                else document.body.classList.remove('session-timeout-active')
            }
        }
    },
    methods: {
        async login() {
            try {
                this.$store.dispatch('userSignOut');
            } 
            catch (e) {
                console.error(e) 
                localStorage.clear();
                window.location.assign('/login')
            }
            finally {
                this.open = false
            }
        }
    },
    beforeDestroy(){
         if (typeof document !== 'undefined') {
            document.body.classList.remove('session-timeout-active')
        }
    }
}
</script>
<style>
   body.session-timeout-active .v-application--wrap > * {
        filter: grayscale(1);
        pointer-events: none;
        user-select: none;
    }

    body.session-timeout-active .v-dialog__content--active {
        filter: none;
        pointer-events: auto;
    }
</style>
